/**
 * GET — Fetch existing contact info
 */
export async function getContactInfo() {
  const response = await fetch(`/api/contact-info`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Error fetching contact info: ${response.statusText}`);
  }

  const data = await response.json();
  return data.data; // matches backend: { success: true, data: contact }
}
